import { render, staticRenderFns } from "./ScreensaversText.vue?vue&type=template&id=5b2c8a7a&scoped=true"
import script from "./ScreensaversText.vue?vue&type=script&lang=js"
export * from "./ScreensaversText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c8a7a",
  null
  
)

export default component.exports